import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PaymentPage from './pages/PaymentPage';
import SuccessPage from './pages/SuccessPage';

/**
 * Zest Payment Request Collection - App Component
 * 
 * Root component with React Router configuration:
 * - /: Payment page (validation + Braintree Drop-in UI)
 * - /success: Payment confirmation page
 */

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<PaymentPage />} />
          <Route path="/success" element={<SuccessPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
